import { keepPreviousData } from '@tanstack/react-query';

import { GetOffersParams } from '../common/api/clients/gateway.api';
import { queries } from '../common/api/queryKeys/queries';
import { usePaginationQuery } from '../common/hooks/usePaginationQuery';

import { OfferModel } from './model/OfferModel';

export const useOfferPagination = ({ page = 0, ...rest }: GetOffersParams) => {
    const nextPage = queries.offers.pagination({ page: page + 1, ...rest });

    return usePaginationQuery<OfferModel>({
        ...queries.offers.pagination({ page, ...rest }),
        options: { placeholderData: keepPreviousData },
        prefetchQueryKey: nextPage.queryKey,
        prefetchQueryFn: nextPage.queryFn,
    });
};
